// extracted by mini-css-extract-plugin
module.exports = {"caretIcon":"LinksMenu-module_caretIcon__kwWVTddY8lSNFduMPudDl","customIcon":"LinksMenu-module_customIcon__3EFyURFp-Zw7aP67y2gPEa"};